import styled from 'styled-components'; // Visit Details

export const VisitDetailTableWrapper = styled.div.withConfig({
  displayName: "WrapperDiv__VisitDetailTableWrapper",
  componentId: "sc-1mzkivg-0"
})(["height:auto;width:100%;overflow:auto;padding-left:10px;padding-right:10px;min-height:10px;"]);
export const VisitDetailDiv = styled.div.withConfig({
  displayName: "WrapperDiv__VisitDetailDiv",
  componentId: "sc-1mzkivg-1"
})(["padding:10px;padding-top:0px;height:auto;white-space:pre-wrap;display:flex;gap:10px;flex-direction:", ";align-items:", ";justify-content:", ";"], ({
  $summary
}) => $summary ? 'row' : 'column', ({
  $summary
}) => $summary ? 'center' : 'flex-start', ({
  $summary
}) => $summary ? 'flex-start' : 'center');
export const HeaderSpan = styled.div.withConfig({
  displayName: "WrapperDiv__HeaderSpan",
  componentId: "sc-1mzkivg-2"
})(["font-weight:bold;font-size:1rem;font-family:inherit;text-decoration:underline;white-space:nowrap;width:min-content;"]); // Visit Header

export const VisitHeaderDiv = styled.div.withConfig({
  displayName: "WrapperDiv__VisitHeaderDiv",
  componentId: "sc-1mzkivg-3"
})(["width:100%;margin-left:20px;margin-bottom:10px;"]);
export const VisitHeaderDetailDiv = styled.div.withConfig({
  displayName: "WrapperDiv__VisitHeaderDetailDiv",
  componentId: "sc-1mzkivg-4"
})(["display:flex;"]);
export const VisitHeaderDetailValueDiv = styled.div.withConfig({
  displayName: "WrapperDiv__VisitHeaderDetailValueDiv",
  componentId: "sc-1mzkivg-5"
})(["padding-left:3px;"]);
export const VisitModalDiv = styled.div.withConfig({
  displayName: "WrapperDiv__VisitModalDiv",
  componentId: "sc-1mzkivg-6"
})(["width:min(100%,max(18rem,min(40rem,30vw)));box-sizing:border-box;"]);
export const TaskSpan = styled.span.withConfig({
  displayName: "WrapperDiv__TaskSpan",
  componentId: "sc-1mzkivg-7"
})(["color:", ";"], props => props.refused ? '#FF6A00' : '');